import { useState } from 'react'
import {
    Upload,
    Form,
    Row,
    Col,
    Button,
    Alert,
    Divider,
    notification,
} from "antd";

import { InboxOutlined } from "@ant-design/icons";
import {
  Notify,
  openNotification} from '@seims/shared';
;

const { Dragger } = Upload;

export default function StartUpload({ setUploadedFiles, setProgressState }) {

    const [showPreview, setShowPreview] = useState(false);


        const handleUpload = (file) => {

            notification.destroy("seims");

            const validFileTypes = [
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "text/csv",
            ].includes(file.type);
            if (!validFileTypes) {
                openNotification(
                    "File Validation",
                    `${file.name} is not a valid file type`,
                    Notify.ERROR
                );
                return Upload.LIST_IGNORE;
            }
            setUploadedFiles(file);
            setShowPreview(true);
            return false
        }
    

    const uploadInfo = {
        accept: ".csv, .xlsx",
        multiple: false,
        showUploadList: true,
        beforeUpload: handleUpload,
    };

    const onFilePreview = () => {
        setProgressState(1);
    };

    const onBack = () => {
        setProgressState(0);
    };

    return (
        <div>
            <Alert
                message="Please note"
                description="Accepted file types are EXCEL and CSV"
                type="info"
                showIcon
            />
            <Divider />
            <Row justify={"center"}>
                <Col xs={24} md={8}>
                    <Form.Item valuePropName="fileList">
                        <Dragger
                            defaultFileList={[]}
                            maxCount={1}
                            multiple={false}
                            {...uploadInfo}

                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            Click or drag file to this area to upload
                        </Dragger>
                    </Form.Item>
                </Col>
            </Row>
            {showPreview && (
                <Row>
                    <Col xs={24} className="right-align">
                        <Button
                            className="right-align-button"
                            onClick={onFilePreview}
                            htmlType="submit"
                            type="primary"
                            style={{ marginTop: "20px" }}
                        >
                            Preview File
                        </Button>
                    </Col>
                </Row>
            )}
        </div>
    )
}
